import axios from 'axios';

// Lista wysyłek
export const getAllCampaigns = async (token: string) => {
	const url = `${process.env.REACT_APP_API_URL}/olympics/email-campaigns`;
	return await axios.get(url, { headers: { Authorization: `Bearer ${token}` } });
};

export const getVisibleCampaigns = async (token: string) => {
	const url = `${process.env.REACT_APP_API_URL}/olympics/email-campaigns/visible`;
	return await axios.get(url, { headers: { Authorization: `Bearer ${token}` } });
};

export const getMyVisibleCampaigns = async (token: string) => {
	const url = `${process.env.REACT_APP_API_URL}/olympics/email-campaigns/my-visible`;
	return await axios.get(url, { headers: { Authorization: `Bearer ${token}` } });
};

export const checkVisibleCampaigns = async (token: string) => {
	const url = `${process.env.REACT_APP_API_URL}/olympics/email-campaigns/check-visibility`;
	return await axios.get(url, { headers: { Authorization: `Bearer ${token}` } });
};

// CRUD wysyłek
export const getCampaignDetails = async (token: string, id: number) => {
	const url = `${process.env.REACT_APP_API_URL}/olympics/email-campaigns/${id}`;
	return await axios.get(url, { headers: { Authorization: `Bearer ${token}` } });
};

export const createCampaign = async (token: string, formData: FormData) => {
	const url = `${process.env.REACT_APP_API_URL}/olympics/email-campaigns`;
	return await axios.post(url, formData, {
		headers: {
			Authorization: `Bearer ${token}`,
			'Content-Type': 'multipart/form-data',
		},
	});
};

export const previewCampaign = async (token: string, formData: FormData) => {
	const url = `${process.env.REACT_APP_API_URL}/olympics/email-campaigns/preview`;
	return await axios.post(url, formData, {
		headers: {
			Authorization: `Bearer ${token}`,
			'Content-Type': 'multipart/form-data',
		},
	});
};

/** POST zamiast PUT: PHP nie parsuje multipart/form-data do $_POST przy PUT — pola (name itd.) były puste. */
export const updateCampaign = async (token: string, id: number, formData: FormData) => {
	const url = `${process.env.REACT_APP_API_URL}/olympics/email-campaigns/${id}`;
	return await axios.post(url, formData, { headers: { Authorization: `Bearer ${token}` } });
};

export const deleteCampaign = async (token: string, id: number) => {
	const url = `${process.env.REACT_APP_API_URL}/olympics/email-campaigns/${id}`;
	return await axios.delete(url, { headers: { Authorization: `Bearer ${token}` } });
};

// Wysyłka
export const sendCampaign = async (token: string, id: number) => {
	const url = `${process.env.REACT_APP_API_URL}/olympics/email-campaigns/${id}/send`;
	return await axios.post(url, {}, { headers: { Authorization: `Bearer ${token}` } });
};

export const resendToRecipients = async (token: string, id: number, recipientIds: number[]) => {
	const url = `${process.env.REACT_APP_API_URL}/olympics/email-campaigns/${id}/recipients/resend`;
	return await axios.post(url, { recipient_ids: recipientIds }, { headers: { Authorization: `Bearer ${token}` } });
};

// Odbiorcy
export const getCampaignRecipients = async (token: string, id: number, filters?: any) => {
	let url = `${process.env.REACT_APP_API_URL}/olympics/email-campaigns/${id}/recipients`;
	const params = new URLSearchParams();
	if (filters?.district_id) params.append('district_id', filters.district_id);
	if (filters?.status) params.append('status', filters.status);
	if (params.toString()) url += `?${params.toString()}`;
	return await axios.get(url, { headers: { Authorization: `Bearer ${token}` } });
};

export const getMyRecipients = async (token: string, id: number) => {
	const url = `${process.env.REACT_APP_API_URL}/olympics/email-campaigns/${id}/my-recipients`;
	return await axios.get(url, { headers: { Authorization: `Bearer ${token}` } });
};

export const addManualRecipient = async (token: string, id: number, recipientData: any) => {
	const url = `${process.env.REACT_APP_API_URL}/olympics/email-campaigns/${id}/recipients/manual`;
	return await axios.post(url, recipientData, { headers: { Authorization: `Bearer ${token}` } });
};

export const getAvailableRecipients = async (
	token: string,
	id: number,
	recipientType?: 'teacher' | 'secretary' | 'student',
) => {
	let url = `${process.env.REACT_APP_API_URL}/olympics/email-campaigns/${id}/available-recipients`;
	if (recipientType) url += `?recipient_type=${recipientType}`;
	return await axios.get(url, { headers: { Authorization: `Bearer ${token}` } });
};

export const updateRecipientComment = async (token: string, recipientId: number, comment: string) => {
	const url = `${process.env.REACT_APP_API_URL}/olympics/email-campaigns/recipients/${recipientId}/comment`;
	return await axios.put(url, { comment }, { headers: { Authorization: `Bearer ${token}` } });
};

export const deleteRecipient = async (token: string, recipientId: number) => {
	const url = `${process.env.REACT_APP_API_URL}/olympics/email-campaigns/recipients/${recipientId}`;
	return await axios.delete(url, { headers: { Authorization: `Bearer ${token}` } });
};

// Statystyki
export const getCampaignStatistics = async (token: string, id: number, groupBy: 'hour' | 'day' = 'hour') => {
	const url = `${process.env.REACT_APP_API_URL}/olympics/email-campaigns/${id}/statistics?group_by=${groupBy}`;
	return await axios.get(url, { headers: { Authorization: `Bearer ${token}` } });
};

export const getMyStatistics = async (token: string, id: number) => {
	const url = `${process.env.REACT_APP_API_URL}/olympics/email-campaigns/${id}/my-statistics`;
	return await axios.get(url, { headers: { Authorization: `Bearer ${token}` } });
};

// Public API (no auth) - Weryfikacja
export const verifyEmailClick = async (token: string) => {
	const url = `${process.env.REACT_APP_API_URL}/olympics/verify-email/${token}`;
	return await axios.get(url);
};

export const verifyPassword = async (token: string, password: string) => {
	const url = `${process.env.REACT_APP_API_URL}/olympics/verify-password`;
	return await axios.post(url, { token, password });
};

export const verifyCode = async (token: string, code: string) => {
	const url = `${process.env.REACT_APP_API_URL}/olympics/verify-code`;
	return await axios.post(url, { token, code });
};
